import React from 'react';

const getStyles = (text) => {
  switch (text) {
    case 'Instagram':
    case 'انستجرام':
      return { 
        bgColor: 'bg-gradient-to-r from-pink-500 to-yellow-500', 
        iconColor: 'text-white',
        hoverBg: 'hover:from-pink-600 hover:to-yellow-600'
      };
    case 'Facebook':
    case 'فيس بوك':
      return { 
        bgColor: 'bg-blue-600', 
        iconColor: 'text-white',
        hoverBg: 'hover:bg-blue-700'
      };
    
      case 'Snapchat':
        case 'سناب شات':
          return {
            bgColor: 'bg-yellow-400',
            iconColor: 'text-white',
            hoverBg: 'hover:bg-yellow-500'
          };
    
        case 'tiktock':
        case 'تيك توك':
          return {
            bgColor: 'bg-black',
            iconColor: 'text-white',
            hoverBg: 'hover:bg-gradient-to-tr hover:from-[#25F4EE] hover:to-[#FE2C55]'
          };

      case 'WhatsApp':
    case 'وتس آب':
      return { 
        bgColor: 'bg-green-500', 
        iconColor: 'text-white',
        hoverBg: 'hover:bg-green-600'
      };
    case 'Address':
    case 'العنوان':
      return { 
        bgColor: 'bg-white', 
        iconColor: 'text-secondColor',
        hoverBg: 'hover:bg-primeColor-50',
        borderColor: 'border border-primeColor-200'
      };
    case 'Email':
    case 'البريد الإلكتروني':
      return { 
        bgColor: 'bg-white', 
        iconColor: 'text-red-500',
        hoverBg: 'hover:bg-red-50',
        borderColor: 'border border-red-200'
      };
    case 'Phone Number':
    case 'رقم الهاتف':
      return { 
        bgColor: 'bg-white', 
        iconColor: 'text-blue-500',
        hoverBg: 'hover:bg-blue-50',
        borderColor: 'border border-blue-200'
      };
    default:
      return { 
        bgColor: 'bg-white', 
        iconColor: 'text-gray-500',
        hoverBg: 'hover:bg-gray-50',
        borderColor: 'border border-gray-200'
      };
  }
};

const SocialSection = ({ icon, text, link, phoneNumber, email, location, isAddress, language }) => {
  const isRTL = language === 'ar';
  const { bgColor, iconColor, hoverBg, borderColor = '' } = getStyles(text);

  let href = link;
  let displayText = text;
  let isExternal = true;
  
  if (phoneNumber) {
    href = `tel:${phoneNumber}`;
    displayText = phoneNumber;
    isExternal = false;
  } else if (location) {
    displayText = location;
    isExternal = true;
  } else if (email) {
    displayText = email;
    isExternal = false;
  }

  const isWhiteBg = bgColor.includes('white') || bgColor.includes('gray-50') || bgColor.includes('primeColor-50') || bgColor.includes('red-50') || bgColor.includes('blue-50');

  return (
    <a
      href={href}
      target={isExternal ? '_blank' : '_self'}
      rel={isExternal ? 'noopener noreferrer' : undefined}
      className={`group relative overflow-hidden rounded-xl ${bgColor} ${hoverBg} ${borderColor} p-4 transition-all duration-300 hover:shadow-md no-underline ${
        isAddress ? 'md:col-span-2' : ''
      }`}
    >
      <div className={`relative z-10 flex items-center gap-3 ${isRTL ? 'flex-row-reverse' : 'flex-row'}`}>
        
        {/* Icon Container */}
        <div className={`flex-shrink-0 w-10 h-10 rounded-lg ${iconColor} flex items-center justify-center transition-all duration-300 ${
          isWhiteBg 
            ? 'bg-gray-100 group-hover:bg-secondColor/10 group-hover:text-secondColor' 
            : 'bg-white/20 group-hover:bg-white/30'
        }`}>
          <span className="text-base">
            {icon}
          </span>
        </div>

        {/* Text Content */}
        <div className={`flex-1 min-w-0 ${isRTL ? 'text-right' : 'text-left'}`}>
          <div className="text-xs font-medium text-gray-500 mb-0.5">
            {text}
          </div>
          <div className={`text-sm font-medium truncate ${
            isWhiteBg ? 'text-gray-800' : 'text-white'
          } group-hover:text-secondColor transition-colors duration-300`}>
            {displayText}
          </div>
        </div>

        {/* Minimal Arrow */}
        <div className={`text-gray-400 group-hover:text-secondColor transition-colors duration-300 ${isRTL ? 'rotate-180' : ''}`}>
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </div>
      </div>
    </a>
  );
};

export default SocialSection;